import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaStar, FaMapMarkerAlt, FaGlobe, FaShoppingBag, FaCommentDots, FaRuler } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { LoginContext } from '../../Contexts/LoginContext';
import { formatCurrency, calculateDistance } from '../../data/constants';

const OfferView = ({ offers, yourAmount, onClose }) => {
  const { currency, exchangeRate, user } = useContext(LoginContext);
  const navigate = useNavigate();

  const handleContactSeller = (sellerUserId) => {
    if (!sellerUserId) return;
    onClose?.();
    navigate(`/chats?p=${sellerUserId}`);
  };

  // Calculate distance between buyer and seller
  const getDistanceToSeller = (offer) => {
    const buyerLoc = user?.location;
    const sellerLoc = offer?.seller?.sellerId?.location;
    if (!buyerLoc?.lat || !buyerLoc?.lon || !sellerLoc?.lat || !sellerLoc?.lon) return null;
    if (buyerLoc.lat === 0 && buyerLoc.lon === 0) return null;
    if (sellerLoc.lat === 0 && sellerLoc.lon === 0) return null;
    return calculateDistance(buyerLoc.lat, buyerLoc.lon, sellerLoc.lat, sellerLoc.lon);
  };

  return (
    <div className="offerViewContainer">
      {offers.map((offer) => {
        const distKm = getDistanceToSeller(offer);
        return (
          <div key={offer._id} className="offerViewCard">
            <div className="offerViewCardHeader">
              <div className="offerViewSellerAvatar">
                <img
                  src={offer?.seller?.sellerId?.profileImage || '/default-avatar.png'}
                  alt={offer?.seller?.sellerId?.displayName || 'Seller'}
                  className="offerViewSellerImage"
                />
              </div>
              <div className="offerViewSellerInfo">
                <h3 className="offerViewSellerName">{offer?.seller?.sellerId?.displayName || 'Seller'}</h3>
                <div className="offerViewSellerRating">
                  <FaStar className="offerViewStarIcon" />
                  <span className="offerViewRatingValue">{offer?.seller?.sellerId?.rating?.toFixed(1) || '0.0'}</span>
                  <span className="offerViewReviewCount">({offer?.seller?.sellerId?.noOfReviews || 0} reviews)</span>
                </div>
                <div className="offerViewSellerMeta">
                  {offer?.seller?.languages && (
                    <span className="offerViewMetaItem">
                      <FaGlobe size={12} />
                      {offer.seller.languages}
                    </span>
                  )}
                  {offer?.seller?.sellerId?.sellerAddress && (
                    <span className="offerViewMetaItem">
                      <FaMapMarkerAlt size={12} />
                      {[offer.seller.sellerId.sellerAddress?.city, offer.seller.sellerId.sellerAddress?.country?.name].filter(Boolean).join(', ')}
                    </span>
                  )}
                  {offer?.seller?.sellerId?.productsSold != null && (
                    <span className="offerViewMetaItem">
                      <FaShoppingBag size={12} />
                      {offer.seller.sellerId.productsSold} orders completed
                    </span>
                  )}
                  {distKm !== null && (
                    <span className="offerViewMetaItem offerViewDistanceBadge">
                      <FaRuler size={12} />
                      {distKm} km away
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="offerViewMessageSection">
              <h4 className="offerViewSectionTitle">
                <FaCommentDots size={16} />
                Message from seller
              </h4>
              <p className="offerViewMessageText">{offer.message || 'No message provided.'}</p>
            </div>

            <div className="offerViewAmountSection">
              <div className="offerViewAmountCard offerViewAmountCardSeller">
                <span className="offerViewAmountLabel">Seller&apos;s quote</span>
                <span className="offerViewAmountValue">{formatCurrency(offer.quotedAmount, currency, exchangeRate)}</span>
              </div>
              <div className="offerViewAmountCard offerViewAmountCardBuyer">
                <span className="offerViewAmountLabel">Your budget</span>
                <span className="offerViewAmountValue">{formatCurrency(yourAmount, currency, exchangeRate)}</span>
              </div>
            </div>

            <div className="offerViewActions">
              <button
                type="button"
                className="offerViewContactBtn"
                onClick={() => handleContactSeller(offer?.seller?._id)}
              >
                <HiOutlineMail size={18} />
                Contact Seller
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OfferView;